// extracted by mini-css-extract-plugin
export var orderDetails = "_ut-2";
export var orderImage = "_ut-1";
export var orderMeta = "_ut-3";
export var orderSummary = "_ut-0";
export var rightArrow = "_ut-4";